var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('keep-alive',[_c('v-img',{staticClass:"shrink mx-2 mt-2",staticStyle:{"cursor":"pointer"},attrs:{"src":_vm.logoAppBar,"height":_vm.logoHeight,"max-width":_vm.logoWidth,"contain":"contain","transition":"scale-transition"},on:{"click":_vm.goHome}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }